'use strict'

export let norwegian={
  general: {
    benefit: "Gevinst",
    businessCase: "Begrunnelse",
  },
  strategy: {
    title: "Strategi og mål",
    fields: {
      reasons: {
        title: "Grunner til å gjennomføre",
        help: `Hvilken del av forretningsstrategien støttes av leveransene fra dette prosjektet?
          Hvis dette prosjektet er en del av et program, hvilke programmål er støttet av prosjektets leveranser?`,
        description: "Grunnen til å gjennomføre prosjektet og hvordan prosjektet vil muliggjøre strategier og nå mål"
      }
    }
  },
  summary: {
    title: "Oppsummering",
    fields: {
      executiveSummary: {
        title: "Sammendrag",
        help: `Hva er hovedgrunnen til at en endring er nødvendig?
          Hva er de viktigste leveransene prosjektet må levere, og hva er de viktigste gevinstene dette vil bringe?
          Hva er den samlede investeringskostnaden og prosjektplanets tidslinje på høyt nivå?
          Hva vet vi om avkastningen av investeringen?`,
        description: "Fremhev viktige gevinster, avkastning på investeringen og andre nøkkelpunkter"
      }
    }
  },
  options: {
    title: "Alternativer",
    fields: {
      doNothing: {
        title: "Konsekvens av å ikke gjøre noe",
        help: `Hvordan er den nåværende situasjonen?
          Hva er konsekvensene dersom ingenting blir gjort?
          Finnes det en tapt mulighet, dersom ingenting blir gjort?
          Blir tid eller penger sløst bort med dagens situasjon?
          Hvordan kan vi være sikre på at "å gjøre ingenting" er et dårlig alternativ?`,
        description: "Beskriv hva som skjer dersom ingenting blir gjort"
      },
      doMinimal: {
        title: "Gjøre minimalt",
        help: `Hva er det minste omfanget som vil gjøre en forskjell i forhold til den nåværende situasjonen?
          Er det et lite skritt som kan gjøres først, og så kan flere gjøres senere?`,
        description: "Beskriv hva som er det minimale som kan gjøres"
      },
      doSomething: {
        title: "Vurderte alternativer",
        help: `Har flere andre alternativer blitt undersøkt? Hvis nei - hvorfor ikke? Hvis ja, hvilke alternativer er undersøkt?
          Hvilke hovedfordeler gir hvert alternativ?
          Hvilket kompleksitetsnivå eller investeringsnivå vil være nødvendig for hvert alternativ?`,
        description: "List opp alternativer som er evaluert. Beskriv hvilket alternativ som er valgt og begrunnelsen."
      }
    }
  },
  benefits: {
    title: "Gevinster",
    fields: {
      benefits: {
        title: "Overordnede gevinster",
        help: `Gevinster er målbare resultater ved bruk av prosjektets leveranser. Du kan se på gevinster som nøkkelparametre (engelsk: KPI) som skal brukes, også etter at prosjektet er avsluttet, for å måle fremdriften i begrunnelsen for prosjektet. Kan du måle forbedret effektivitet, lavere kostnad, bedre data eller økt produktkvalitet, økt bruk, bedre stabilitet, bedre responstid, bedre kundetilfredshet, økt etterlevelse eller økt markedsandel?`,
        columns: {
          no: {title: "Id" },
          title: {title: "Gevinst" },
          baseline: {title: "Nå-verdi" },
          goal: {title: "Mål" },
          accountable: {title: "Ansvarlig" }
        },
        options: {
          addEntry: {
            title: "Legg til gevinst"
          }
        }
      }
    }
  },
  returnOnInvestment: {
    title: "Avkastning",
    fields: {
      projectPlanSummary: {
        title: "Oppsummering av prosjektplanen",
        help: `Hva er prosjektets totale investering?
          Hvor lenge skal prosjektet vare? I hvilken periode vil gevinstene bli realisert?
          Hva blir kostnaden ved pågående drift og vedlikehold?`,
        description: "Beskriv total investering og forventet tidsperiode for prosjektet"
      },
      investmentAppraisal: {
        title: "Investeringsvurdering",
        help: `Hva er verdien av gevinstene, og hvordan er den sammenlignet med de totale investeringene som trengs?
          Hvor kommer investeringsfinansieringen fra? Hvor kommer vedlikeholdskostnaden fra?
          Kan du kvantifisere avkastningen på investeringen ved å beskrive når investeringen vil bli betalt
          tilbake, hva er nåtidsverdien, eller hva er den interne avkastningen?`,
        description: "Sammenlign samlede investeringer med planlagte gevinster. Avkastning på investeringen. Netto nåverdi. etc."
      },
      risks: {
        title: "Overordnet risiko",
        help: `Er det noen spesifikke risikoer for prosjektet og forretningssaken?
          I så fall, hva er den sannsynlige effekten de risikerer?
          Hva skal gjøres for å redusere disse risikoene?`,
        description: "Risiko knyttet til prosjektet sammen med sannsynlig innvirkning og planer dersom de skulle forekomme."
      }
    }
  },
  benefitDetails: {
    title:"Gevinstdetaljer",
    fields: {
      title: {
        title: "Gevinsttittel",
        description: "Kort beskrivende navn på gevinsten"
      },
      accountable:{
        title: "Ansvarlig",
        help: `Hvem må følge opp og sørge for at denne gevinsten blir realisert - også etter at prosjektet er ferdig?`,
        description: "Navn på den ansvarlige for gevinsten"
      },
      measurement: {
        title: "Hvordan og når kan gevinsten bli målt",
        help: `Er det en teknikk som brukes til å måle denne gevinsten? Eventuelle verktøy eller metoder?
          Når skal denne fordelen måles? Underveis i prosjektet? Etter prosjektet er avsluttet?
          Skal en nåverdi måles før prosjektet gjenomføres?`,
        description: "Beskriv hvordan denne fordelen kan måles og når den skal måles"
      },
      actions: {
        title: "Tiltak fra ledelsen og ressurser",
        help: `Er det noen ledelsesaktiviteter som kreves for å sikre at prosjektets resultater blir oppnådd?
          Eventuelle ressurser (folk, penger, verktøy etc.) behøvde å følge opp fordelsmålinger og nytteverdi?`,
        description: "Angi hvilke aktiviteter ledelsen må iverksette for å realisere fordeler og hvilke ressurser som er nødvendig."
      },
      baseline: {
        title: "Nå-verdi",
        help: `Hva er den målbare verdien av denne fordelen før prosjektet utføres?`,
        description: "Målbar verdi før prosjektet gjennomføres"
      },
      goal: {
        title: "Mål",
        help: `Hva er målbart sluttmål for denne fordelen knyttet til forretningssaken?`,
        description: "Målbart mål"
      }
    }
  }
}



// WEBPACK FOOTER //
// ./views/businessCase/labels/norwegian.js